import React, { useMemo } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Accuracy = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { t } = useTranslation();

  const accuracy = useMemo( () => {
    if ( 'Y' !== answeringQuestions.data.hstYn && 10 >= answeringQuestions.answeringCount ) {
      return answeringQuestions.data.explAcrcyRt / 10 * answeringQuestions.answeringCount;
    } else {
      return answeringQuestions.data.explAcrcyRt;
    }
  }, [ answeringQuestions.data.hstYn, answeringQuestions.data.explAcrcyRt, answeringQuestions.answeringCount ] );

  return (
    <div className="qa-as-wrap">
      <div className="accuracy-cont">
        <div className="accuracy">
          <div className="accuracy-bar" style={ { width : `${ accuracy || 0 }%` } } />
          <div className="accuracy-line">
            <span className="line line1" />
            <span className="line line2" />
            <span className="line line3" />
          </div>
          <p className="tit">{ t( 'LC_05_20.msg003' ) }</p>
        </div>
        <div className="accuracy-labelbox">
          <div className={ clsx( 'a-label', 'label1', 0 < accuracy && 'on' ) } />
          <div className={ clsx( 'a-label', 'label2', 66.6 < accuracy && 'on' ) }><span className="ico" /></div>
          <div className={ clsx( 'a-label', 'label3', 80.0 < accuracy && 'on' ) }><span className="ico" /></div>
          <div className={ clsx( 'a-label', 'label4', 95.0 < accuracy && 'on' ) }><span className="ico" /></div>
        </div>
      </div>
    </div>
  );

};

export default Accuracy;
